module.exports = __webpack_public_path__ + "static/media/thumbnail.f6cd5da1.jpg";